import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "walk-talk-panel",
  "aria-label": "边走边说顺序列表"
}
const _hoisted_2 = { class: "list-toolbar" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_5 = {
  key: 0,
  role: "alert"
}
const _hoisted_6 = ["data-entry-id", "aria-label"]
const _hoisted_7 = { class: "dialogue-row" }
const _hoisted_8 = ["aria-label", "onPointerdown", "onKeydown"]
const _hoisted_9 = { class: "order" }
const _hoisted_10 = {
  viewBox: "0 0 16 20",
  width: "14",
  height: "18",
  "aria-hidden": "true"
}
const _hoisted_11 = ["cx", "cy"]
const _hoisted_12 = { class: "talker-field" }
const _hoisted_13 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_14 = { class: "subtitle-field" }
const _hoisted_15 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_16 = { class: "content-field" }
const _hoisted_17 = { class: "style-field" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "delay-field" }
const _hoisted_21 = { class: "delay-input" }
const _hoisted_22 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = ["aria-expanded", "aria-controls", "aria-label", "onClick"]
const _hoisted_25 = ["disabled", "aria-label", "onClick"]
const _hoisted_26 = ["aria-label", "onClick"]
const _hoisted_27 = ["id"]
const _hoisted_28 = {
  key: 1,
  class: "drop-end",
  "aria-hidden": "true"
}
const _hoisted_29 = {
  key: 2,
  class: "list-empty"
}
const _hoisted_30 = { class: "ghost-content" }

import StudioSelectField from "../StudioSelectField.vue";
import { ref } from "vue";
import { toast } from "vue-sonner";
import { addWalkTalkEntry, removeWalkTalkEntry, WALK_TALK_LIMIT, type WalkTalkProject } from "./walkTalkProject";
import { useStylePresets } from "../EntityPresetEditor/stylePresets";
import AutoGrowTextarea from "./AutoGrowTextarea.vue";
import { useWalkTalkReorder } from "./useWalkTalkReorder";

export default /*@__PURE__*/_defineComponent({
  __name: 'WalkTalkPanel',
  props: {
    project: {}
  },
  setup(__props: any) {

const { options: WALK_TALK_STYLE_OPTIONS, error: styleError, retry: retryStyles } = useStylePresets("walkTalkStyles");
const props = __props;
const list = ref<HTMLElement>();
const expanded = ref(new Set<string>());
const { draggingId, beforeId, validDrop, ghost, announcement, start, keyboardMove } = useWalkTalkReorder(() => props.project, list);
function toggleDetails(id: string) {
  if (expanded.value.has(id)) expanded.value.delete(id);
  else expanded.value.add(id);
}
function add(afterId?: string) {
  try { addWalkTalkEntry(props.project, afterId); }
  catch (error) { toast.warning(error instanceof Error ? error.message : String(error)); }
}
function remove(id: string, index: number) {
  if (confirm(`删除第 ${index + 1} 条台词？其余台词将按当前顺序保留。`)) {
    removeWalkTalkEntry(props.project, id);
    expanded.value.delete(id);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("strong", null, "顺序台词", -1)),
        _createElementVNode("small", null, _toDisplayString(__props.project.entries.length) + "/" + _toDisplayString(_unref(WALK_TALK_LIMIT)) + " 条 · 拖动左侧把手调整顺序", 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "primary",
        disabled: __props.project.entries.length >= _unref(WALK_TALK_LIMIT),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
      }, "＋ 添加台词", 8, _hoisted_3)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(announcement)), 1),
    _createElementVNode("div", {
      ref_key: "list",
      ref: list,
      class: _normalizeClass(["dialogue-list", { 'is-dragging': _unref(draggingId) }])
    }, [
      (_unref(styleError))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(styleError)) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(retryStyles)().catch(() => undefined)))
            }, "重试类型预设")
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.project.entries, (entry, index) => {
        return (_openBlock(), _createElementBlock("article", {
          key: entry.id,
          class: _normalizeClass(["dialogue-card", { 'drag-source': _unref(draggingId) === entry.id, 'drop-before': _unref(draggingId) && _unref(validDrop) && _unref(beforeId) === entry.id }]),
          "data-entry-id": entry.id,
          "aria-label": `第 ${index + 1} 条台词`
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "drag-handle",
              "aria-label": `拖动第 ${index + 1} 条台词调整顺序，也可按 Alt 加上下方向键`,
              title: "拖动调整顺序 · Alt + ↑ / ↓",
              onPointerdown: ($event: any) => (_unref(start)($event, entry.id)),
              onKeydown: ($event: any) => (_unref(keyboardMove)($event, entry.id))
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(String(index + 1).padStart(2, '0')), 1),
              (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                  return _createElementVNode("circle", {
                    key: n,
                    cx: n % 2 ? 5 : 11,
                    cy: 4 + Math.floor((n - 1) / 2) * 6,
                    r: "1.5",
                    fill: "currentColor"
                  }, null, 8, _hoisted_11)
                }), 64))
              ]))
            ], 40, _hoisted_8),
            _createElementVNode("label", _hoisted_12, [
              _cache[4] || (_cache[4] = _createTextVNode("说话人", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((entry.talker) = $event),
                "aria-label": `第 ${index + 1} 条说话人`,
                placeholder: "说话人"
              }, null, 8, _hoisted_13), [
                [_vModelText, entry.talker]
              ])
            ]),
            _createElementVNode("label", _hoisted_14, [
              _cache[5] || (_cache[5] = _createTextVNode("副标题", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((entry.subtitle) = $event),
                "aria-label": `第 ${index + 1} 条副标题`,
                placeholder: "可留空"
              }, null, 8, _hoisted_15), [
                [_vModelText, entry.subtitle]
              ])
            ]),
            _createElementVNode("label", _hoisted_16, [
              _cache[6] || (_cache[6] = _createTextVNode("台词内容", -1)),
              _createVNode(AutoGrowTextarea, {
                modelValue: entry.content,
                "onUpdate:modelValue": ($event: any) => ((entry.content) = $event),
                "aria-label": `第 ${index + 1} 条内容`,
                placeholder: "填写台词内容…"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label"])
            ]),
            _createElementVNode("label", _hoisted_17, [
              _cache[7] || (_cache[7] = _createTextVNode("样式", -1)),
              _createVNode(StudioSelectField, {
                modelValue: entry.style,
                "onUpdate:modelValue": ($event: any) => ((entry.style) = $event),
                title: entry.style,
                "aria-label": `第 ${index + 1} 条样式`
              }, {
                default: _withCtx(() => [
                  (!_unref(WALK_TALK_STYLE_OPTIONS).some(option => option.value === entry.style))
                    ? (_openBlock(), _createElementBlock("option", {
                        key: 0,
                        value: entry.style,
                        disabled: ""
                      }, _toDisplayString(entry.style ? `${entry.style}（旧值）` : '未设置（旧值）'), 9, _hoisted_18))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WALK_TALK_STYLE_OPTIONS), (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_19))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "title", "aria-label"])
            ]),
            _createElementVNode("label", _hoisted_20, [
              _cache[9] || (_cache[9] = _createTextVNode("推进延迟", -1)),
              _createElementVNode("span", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((entry.continueDelay) = $event),
                  inputmode: "decimal",
                  "aria-label": `第 ${index + 1} 条推进延迟`
                }, null, 8, _hoisted_22), [
                  [_vModelText, entry.continueDelay]
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "秒", -1))
              ])
            ]),
            _createElementVNode("div", {
              class: "card-actions",
              role: "group",
              "aria-label": `第 ${index + 1} 条台词操作`
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["details-button", { 'has-details': entry.params }]),
                "aria-expanded": expanded.value.has(entry.id),
                "aria-controls": `walk-talk-details-${entry.id}`,
                "aria-label": `第 ${index + 1} 条整数参数`,
                title: "整数参数",
                onClick: ($event: any) => (toggleDetails(entry.id))
              }, "更多", 10, _hoisted_24),
              _createElementVNode("button", {
                type: "button",
                disabled: __props.project.entries.length >= _unref(WALK_TALK_LIMIT),
                "aria-label": `在第 ${index + 1} 条之后插入台词`,
                title: "在下方插入台词",
                onClick: ($event: any) => (add(entry.id))
              }, "＋", 8, _hoisted_25),
              _createElementVNode("button", {
                type: "button",
                class: "danger",
                "aria-label": `删除第 ${index + 1} 条台词`,
                title: "删除台词",
                onClick: ($event: any) => (remove(entry.id, index))
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("svg", {
                  viewBox: "0 0 20 20",
                  width: "15",
                  height: "15",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M3 5h14M7 5V3h6v2M5 5l1 12h8l1-12M8 8v6m4-6v6" })
                ], -1)
              ]))], 8, _hoisted_26)
            ], 8, _hoisted_23)
          ]),
          _withDirectives(_createElementVNode("div", {
            id: `walk-talk-details-${entry.id}`,
            class: "extra-fields"
          }, [
            _createElementVNode("label", null, [
              _cache[11] || (_cache[11] = _createTextVNode("整数参数 ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("small", null, "逗号、空格或换行分隔，最多 100 项", -1)),
              _createVNode(AutoGrowTextarea, {
                modelValue: entry.params,
                "onUpdate:modelValue": ($event: any) => ((entry.params) = $event),
                "aria-label": `第 ${index + 1} 条整数参数`,
                placeholder: "例如：0, 1, 100"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label"])
            ])
          ], 8, _hoisted_27), [
            [_vShow, expanded.value.has(entry.id)]
          ])
        ], 10, _hoisted_6))
      }), 128)),
      (_unref(draggingId) && _unref(validDrop) && _unref(beforeId) === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28))
        : _createCommentVNode("", true),
      (!__props.project.entries.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _cache[13] || (_cache[13] = _createElementVNode("h3", null, "从第一句台词开始", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "添加说话人和内容，按顺序编排这段对话。", -1)),
            _createElementVNode("button", {
              class: "primary",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (add()))
            }, "＋ 添加第一句台词")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(draggingId))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "walk-talk-drag-ghost",
            style: _normalizeStyle({ left: _unref(ghost).left + 'px', top: _unref(ghost).top + 'px', width: _unref(ghost).width + 'px' }),
            "aria-hidden": "true"
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "⠿", -1)),
            _createElementVNode("strong", null, _toDisplayString(_unref(ghost).talker), 1),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(ghost).content), 1)
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})